import React from 'react';
import { IndexCoordinatorDelegate } from "../IndexCoordinator";
import { PoisonViewControllerDelegate, PoisonViewController } from "../../Screen/Poison/PoisonViewController";
import { TableGenericViewControllerDelegate, TableGenericViewController } from "../../Screen/TableGeneric/TableGenericViewController";
import { TableGenericViewModel } from "../../Screen/TableGeneric/TableGenericViewModel";
import { PoisonViewModel } from '../../Screen/Poison/PoisonViewModel';
import ProtectedRoute from '../../Components/ProtectedRoute';

export class PoisonCoordinator implements IndexCoordinatorDelegate, PoisonViewControllerDelegate, TableGenericViewControllerDelegate {

    getRoute(): JSX.Element[] {
        return [
            this.routeTable(),
            this.routeForm()
        ]
    }

    private routeTable(): JSX.Element {
        var viewModel = new TableGenericViewModel("gepveneno")
        return (<ProtectedRoute requiredPermissions={['dengue.veneno.*']} path="/:base/dengue/veneno" exact={true} component={(props: any) => {
            return (<TableGenericViewController
                permissions={{
                    add: 'dengue.veneno.adicionar',
                    edit: 'dengue.veneno.editar',
                    delete: 'dengue.veneno.excluir',
                }}
                navigation={props}
                viewModel={viewModel}
                delegate={this}
                title={"Veneno"}
            />)
        }} />)
    }

    private routeForm(): JSX.Element {
        var viewModel = new PoisonViewModel()
        return (<ProtectedRoute requiredPermissions={['dengue.veneno.adicionar', 'dengue.veneno.editar']} path="/:base/dengue/veneno/cad/:id" exact={true} component={(props: any) => {
            var idPk = props.match.params.id
            return (<PoisonViewController
                navigation={props}
                viewModel={viewModel}
                delegate={this}
                idPrimary={idPk}
            />)
        }} />)
    }

    tapDimiss(navigation: any): void {
        navigation.history.goBack();
    }

    add(navigation: any, viewModel: TableGenericViewModel): void {
        if (viewModel.getTable() == "gepveneno") {
            navigation.history.push(`veneno/cad/0`);
            return;
        }
    }

    edit(navigation: any, idSelection: number, viewModel: TableGenericViewModel): void {
        if (viewModel.getTable() == "gepveneno") {
            navigation.history.push(`veneno/cad/${idSelection}`);
            return;
        }
    }

}